module.exports = __webpack_public_path__ + "static/media/crossIcon.2c5e15b8.svg";